export default __webpack_public_path__ + "static/media/implementingDigitalTransformation.5008dcd8.jpg";